var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('loading-default',{attrs:{"loadingVisible":_vm.loadingVisible,"headline":_vm.loadingHeadline,"excerpt":_vm.loadingExcerpt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }